



































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Caixa, posicaoDoBalaoDeNovidade } from '@/shareds/chat-de-suporte'

const ESPERA_AO_ABRIR_MS = 600
const PROCURA_DO_BOTAO_MS = 700
const FOLGA_DO_FOCO = 6
const SAIDA_MS = 200

/**
 * Destaque da primeira olhada no botão de troca de tela da barra (BotaoDeTrocaDeTela), no visual do destaque do chat
 * de suporte: a tela escurece em volta do botão e fica travada até "Agora não" ou "Abrir a nova tela". Quem decide se
 * ele aparece, e o que cada resposta grava, é a tela que o usa.
 */
@Component
export default class DestaqueDaTrocaDeTela extends Vue {
	@Prop({ type: String, required: true }) titulo!: string
	@Prop({ type: String, required: true }) texto!: string

	alvo: Caixa | null = null
	larguraDaTela = window.innerWidth
	saindo = false
	espera?: number
	procura?: number

	get escuro() {
		return this.$vuetify.theme.dark
	}

	get posicao() {
		return this.alvo
			? posicaoDoBalaoDeNovidade(this.alvo, this.larguraDaTela)
			: { top: 0, left: 0, largura: 0, seta: 0 }
	}

	get estiloDoFoco() {
		const alvo = this.alvo
		if (!alvo) return {}
		return {
			top: `${alvo.top - FOLGA_DO_FOCO}px`,
			left: `${alvo.left - FOLGA_DO_FOCO}px`,
			width: `${alvo.width + 2 * FOLGA_DO_FOCO}px`,
			height: `${alvo.height + 2 * FOLGA_DO_FOCO}px`,
		}
	}

	// Ao sair, o balão encolhe na direção da seta, que aponta para o botão
	get estiloDoBalao() {
		return {
			top: `${this.posicao.top}px`,
			left: `${this.posicao.left}px`,
			width: `${this.posicao.largura}px`,
			transformOrigin: `${this.posicao.seta}px 0`,
		}
	}

	mounted() {
		window.addEventListener('resize', this.medir)
		// Dá tempo de a tela e a barra se desenharem antes de escurecer em volta do botão
		this.espera = window.setTimeout(() => {
			this.medir()
			// O botão nasce com a barra e pode mudar de lugar: segue medindo enquanto o destaque existir
			this.procura = window.setInterval(this.medir, PROCURA_DO_BOTAO_MS)
		}, ESPERA_AO_ABRIR_MS)
	}

	beforeDestroy() {
		window.removeEventListener('resize', this.medir)
		window.removeEventListener('keydown', this.segurarTeclado, true)
		window.clearTimeout(this.espera)
		window.clearInterval(this.procura)
	}

	@Watch('alvo')
	aoMostrar(alvo: Caixa | null, anterior: Caixa | null) {
		if (alvo && !anterior) {
			window.addEventListener('keydown', this.segurarTeclado, true)
			this.$nextTick(() => this.focar('abrir'))
		} else if (!alvo) {
			window.removeEventListener('keydown', this.segurarTeclado, true)
		}
	}

	focar(botao: 'abrir' | 'agoraNao') {
		const elemento = this.$refs[botao] as HTMLElement | undefined
		if (elemento) elemento.focus()
	}

	/**
	 * Com o destaque na tela, o teclado não chega aos atalhos do sistema: o Tab alterna entre as duas ações e o Esc vale
	 * "Agora não". Enter e espaço nos botões seguem funcionando: a ação padrão do botão não depende da propagação.
	 */
	segurarTeclado(evento: KeyboardEvent) {
		evento.stopPropagation()
		if (evento.key === 'Escape') {
			evento.preventDefault()
			this.agoraNao()
		} else if (evento.key === 'Tab') {
			evento.preventDefault()
			this.focar(document.activeElement === this.$refs.abrir ? 'agoraNao' : 'abrir')
		}
	}

	medir() {
		if (this.saindo) return
		this.larguraDaTela = window.innerWidth
		// Um diálogo aberto ou o destaque do chat, que também trava a tela, saem da frente primeiro
		const ocupada = document.querySelector('.v-dialog__content--active') !== null
			|| Array.from(document.querySelectorAll<HTMLElement>('.destaque-do-chat__balao'))
				.some(balao => balao.getBoundingClientRect().width > 0)
		const caixa = ocupada
			? undefined
			: Array.from(document.querySelectorAll<HTMLElement>('[data-troca-de-tela]'))
				.map(botao => botao.getBoundingClientRect())
				.find(retangulo => retangulo.width > 0 && retangulo.height > 0)
		const novo = caixa ? { top: caixa.top, left: caixa.left, width: caixa.width, height: caixa.height } : null
		const atual = this.alvo
		const igual = !!novo && !!atual
			&& novo.top === atual.top && novo.left === atual.left
			&& novo.width === atual.width && novo.height === atual.height
		if (!igual && (novo || atual)) this.alvo = novo
	}

	agoraNao() {
		if (this.saindo) return
		this.saindo = true
		window.removeEventListener('keydown', this.segurarTeclado, true)
		const semAnimacao = window.matchMedia('(prefers-reduced-motion: reduce)').matches
		window.setTimeout(() => this.$emit('agora-nao'), semAnimacao ? 0 : SAIDA_MS)
	}

	abrir() {
		if (this.saindo) return
		this.saindo = true
		window.removeEventListener('keydown', this.segurarTeclado, true)
		this.$emit('abrir')
	}
}
